import { useTranslation } from 'react-i18next'
import { CategoryArchive } from '@/components/sections'
import type { Line } from '@/data/products'

const lineOrder: Line[] = ['spring-collection', 'novita-edizioni']

export function CategoryNovitaPage() {
  const { t } = useTranslation('common')
  return (
    <CategoryArchive
      category="novita"
      lineOrder={lineOrder}
      hero={{
        eyebrow: t('categoryNovita.hero.eyebrow'),
        title: t('categoryNovita.hero.title'),
        titleItalic: t('categoryNovita.hero.titleItalic'),
        intro: t('categoryNovita.hero.intro'),
        image: '/images/categories/novita-hero.jpg',
        imageAlt: t('categoryNovita.hero.imageAlt'),
      }}
      faq={{
        eyebrow: t('categoryNovita.faq.eyebrow'),
        title: t('categoryNovita.faq.title'),
        titleItalic: t('categoryNovita.faq.titleItalic'),
        body: (
          <>
            <p>{t('categoryNovita.faq.bodyParagraph1')}</p>
            <p>{t('categoryNovita.faq.bodyParagraph2')}</p>
          </>
        ),
        closingNumber: t('categoryNovita.faq.closingNumber'),
        closingNote: (
          <>
            {t('categoryNovita.faq.closingNoteLine1')}
            <br />
            <span className="text-bruno">{t('categoryNovita.faq.closingNoteLine2')}</span>
          </>
        ),
      }}
      labels={{
        filterByLine: t('categoryNovita.archiveLabels.filterByLine'),
        scrollLeft: t('categoryNovita.archiveLabels.scrollLeft'),
        scrollRight: t('categoryNovita.archiveLabels.scrollRight'),
        all: t('categoryNovita.archiveLabels.all'),
        linePrefix: t('categoryNovita.archiveLabels.linePrefix'),
        productsSuffix: t('categoryNovita.archiveLabels.productsSuffix'),
        defaultEyebrow: t('categoryNovita.archiveLabels.defaultEyebrow'),
        defaultFaqEyebrow: t('categoryNovita.archiveLabels.defaultFaqEyebrow'),
        categoryAriaLabel: t('categoryNovita.hero.ariaLabel'),
      }}
    />
  )
}
